export const RECEIVE_CUSTOMER = 'RECEIVE_CUSTOMER';
export const SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS';
export const LIST_CUSTOMER_FIRMS = 'LIST_CUSTOMER_FIRMS';
export const LIST_HISTORY = 'LIST_HISTORY';
export const RESET_SEARCH = 'RESET_SEARCH';
export const RECEIVE_COUNTRY = 'RECEIVE_COUNTRY';
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE';
export const RECEIVE_CUSTOMER_FIRM = 'RECEIVE_CUSTOMER_FIRM';